import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import UserAuthLayout from "../../../Layout/UserAuthLayout"
import { AuthUserApi } from '../../../utils/api';
import BankDetails from './BankDetails';
import PaymentGatewayForm from './PaymentGatewayForm';

const PaymentGateway = () => {
    return (
        <>
            <UserAuthLayout>
                <div className="container-fluid py-4">
                    <div className="row">
                        <div className="col-12 col-md-12">
                            <div className="card">
                                <div className="card-body p-3">
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-uppercase mb-3">purchase hvam by using Fiat money</h6>
                                        </div>
                                        <PaymentGatewayForm
                                            type="add"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="card bg-white mt-3">
                                <div className="card-body">
                                    <BankDetails/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </UserAuthLayout>
        </>
    )
}

export default PaymentGateway